var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTumorBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.691,
    height: 64,
    viewBox: "0 0 57.691 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.691,
    height: 64,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.171,17.191C51.063,24.45,57.19,30.153,57.662,36.375c.471,6.175-4.713,12.868-10.653,18.147C41.117,59.848,34.424,63.807,27.637,64c-6.834.142-13.763-3.535-18.854-8.861a31.917,31.917,0,0,1-8.72-19.75A35.648,35.648,0,0,1,6.8,12.76C11.847,5.5,19.812-1,26.647.128c6.881,1.084,12.585,9.851,18.524,17.063",
    transform: "translate(0 0)",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49.474,101.789H28.469a1.313,1.313,0,0,1-1.313-1.313V97.851a1.313,1.313,0,0,0-2.626,0v2.626a3.939,3.939,0,0,0,3.939,3.939H49.474a1.313,1.313,0,1,0,0-2.626",
    transform: "translate(-14.064 -55.348)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.761,97.851V103.1a1.313,1.313,0,1,0,2.626,0V97.851a1.313,1.313,0,0,0-2.626,0",
    transform: "translate(-42.29 -55.348)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.838,42.467V66.1a1.313,1.313,0,1,0,2.626,0V42.467a1.313,1.313,0,0,0-2.626,0",
    transform: "translate(-21.12 -23.595)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.161,64.785V61.5a1.313,1.313,0,1,1,2.626,0V66.1a1.313,1.313,0,0,1-1.313,1.313H25.843A1.313,1.313,0,0,1,24.53,66.1V45.093a3.938,3.938,0,0,1,3.939-3.939h3.939a1.313,1.313,0,1,1,0,2.626H28.469a1.313,1.313,0,0,0-1.313,1.313V64.785Z",
    transform: "translate(-14.064 -23.595)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.425,48.62a1.315,1.315,0,0,1-1.314,1.314h-9.19a1.314,1.314,0,0,1,0-2.628h9.19a1.315,1.315,0,0,1,1.314,1.314",
    transform: "translate(-38.764 -27.122)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.425,60.93a1.311,1.311,0,0,1-1.314,1.31h-9.19a1.312,1.312,0,0,1,0-2.624h9.19a1.315,1.315,0,0,1,1.314,1.314",
    transform: "translate(-38.764 -34.18)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.912,35H57.473a5.254,5.254,0,0,0-5.252,5.252v7.876a5.252,5.252,0,0,0,5.252,5.252h7.565l10.227,5.111a1.311,1.311,0,0,0,1.9-1.173V40.248A5.254,5.254,0,0,0,71.912,35M74.54,55.19l-8.6-4.3a1.339,1.339,0,0,0-.589-.137H57.473a2.629,2.629,0,0,1-2.628-2.628V40.248a2.626,2.626,0,0,1,2.628-2.624H71.912a2.626,2.626,0,0,1,2.628,2.624Z",
    transform: "translate(-29.94 -20.064)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.438,41.156H61a2.626,2.626,0,0,0-2.628,2.624v7.876A2.629,2.629,0,0,0,61,54.285h7.876a1.339,1.339,0,0,1,.589.137l8.6,4.3V43.78a2.626,2.626,0,0,0-2.628-2.624m-2.624,10.5h-9.19a1.312,1.312,0,0,1,0-2.624h9.19a1.312,1.312,0,1,1,0,2.624m0-5.248h-9.19a1.314,1.314,0,0,1,0-2.628h9.19a1.314,1.314,0,1,1,0,2.628",
    transform: "translate(-33.466 -23.596)",
    fill: "#02e2ff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumorBoard);
export default __webpack_public_path__ + "static/media/tumor_board.a1db5cfbde096a602d0296c04e2ae515.svg";
export { ForwardRef as ReactComponent };